import { useEffect, useState, type ReactNode } from 'react';

interface BottomSheetProps {
  children: ReactNode;
  className?: string;
}

export function BottomSheet({ children, className }: BottomSheetProps) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const id = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div
      className={
        'pointer-events-none absolute inset-x-0 bottom-0 z-[1000] flex justify-center ' +
        'pb-[max(env(safe-area-inset-bottom),16px)] ' +
        (className ?? '')
      }
    >
      <div
        className={
          'pointer-events-auto w-full max-w-mobile rounded-t-3xl bg-white shadow-sheet transition-all duration-300 ease-out ' +
          (mounted ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0')
        }
      >
        <div className="flex justify-center pt-2">
          <span className="h-1.5 w-10 rounded-full bg-line" aria-hidden="true" />
        </div>
        <div className="px-4 pb-4 pt-3">{children}</div>
      </div>
    </div>
  );
}
